import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from '@/store/bya3/auth'
import pages from '@/store/bya3/pages'
import poster from '@/store/bya3/poster'
import reply from '@/store/bya3/reply'
import webview from '@/store/bya3/webview'
import navigation from '@/store/bya3/navigation'
import subscription from '@/store/bya3/subscription'
import instagram from '@/store/bya3/instagram'
import shop from '@/store/bya3/shop'
import bot from '@/store/bya3/bot'
import vcards from '@/store/bya3/vcards'

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    pages,
    poster,
    reply,
    webview,
    navigation,
    subscription,
    instagram,
    bot,
    shop,
    vcards,
  },
  strict: process.env.DEV,
})
